import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem'
  },
  references: {
    color: theme.vars.palette.primary.dark,
    wordBreak: 'break-word'
  }
}));

export default useStyles;
